export const dialogClockMixin = {
  data() {
    return {
      time: '11:02'
    }
  },
  methods: {
    startClock() {
      let today = new Date()
      let h = today.getHours()
      let m = today.getMinutes()
      m = this.checkTime(m)
      this.time = h + ':' + m
      this.timeTimer = setTimeout(this.startClock, 500)
    },
    checkTime(i) {
      if (i < 10) {
        i = '0' + i
      } // add zero in front of numbers < 10
      return i
    },
    destroyClock() {
      clearTimeout(this.timeTimer)
    }
  },
  mounted() {
    this.startClock()
  },
  beforeUnmount() {
    this.destroyClock()
  }
}
